import { render, staticRenderFns } from "./HotNewGoods.vue?vue&type=template&id=e6755988&"
import script from "./HotNewGoods.vue?vue&type=script&lang=js&"
export * from "./HotNewGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports